import axios from 'axios'
import Vue from 'vue'
import VueCookies from 'vue-cookie'
import vuetify from './plugins/vuetify'
import App from './App.vue'
import store from "./store"
import router from "./router"
import cfg from "./cfg"

Vue.config.productionTip = false
Vue.use(VueCookies)
Vue.prototype.$cfg = cfg


axios.defaults.withCredentials = true;

// `baseURL` is prepended to URLs passed to axios
axios.defaults.baseURL = cfg.ACCOUNTS_API_URL

// POST with JSON content type
axios.defaults.headers.post['Content-Type'] = 'application/json'

// It gives you easy global access to it instead use import
Vue.prototype.$axios = axios.create()

axios
  .get(cfg.ACCOUNTS_API_URL + "users")
  .then((response) => {
    store.commit('SET_USER', response.data)
    store.commit('SET_AUTH', true)
  })
  .catch(() => {
    store.commit('SET_USER', null)
    store.commit('SET_AUTH', false)
  })
  .then(()=>{
    new Vue({
      vuetify,
      router,
      store,
      render: h => h(App)
    }).$mount('#app')
  })


